/**
 * cssFontFace generates a string representation of the css @font-face rule
 * Note that this is necessary to make sure that we load all the fonts we need
 *
 * It was brought up here: https://github.com/mui-org/material-ui/issues/24966#issuecomment-780045031
 * and was resolved in: https://github.com/mui-org/material-ui/pull/25583
 */
const cssFontFace = (
  name: string,
  src: String,
  fontWeight: string | number = 'normal',
  fontStyle: string = 'normal'
) => `
@font-face {
  font-family: ${name};
  src: url(https://media-cdn.getbento.com/fonts/circular/${src}.eot?#iefix) format('embedded-opentype'),
       url(https://media-cdn.getbento.com/fonts/circular/${src}.otf) format('opentype'),
       url(https://media-cdn.getbento.com/fonts/circular/${src}.woff) format('woff'),
       url(https://media-cdn.getbento.com/fonts/circular/${src}.woff2) format('woff2'),
       url(https://media-cdn.getbento.com/fonts/circular/${src}.ttf) format('truetype'),
       url(https://media-cdn.getbento.com/fonts/circular/${src}.svg#${name}) format('svg');
  font-style: ${fontStyle};
  font-weight: ${fontWeight};
  font-display: swap;
}
`;

export const CIRCULAR_STD = 'CircularStd';
export const CIRCULAR_STD_BOOK = `${CIRCULAR_STD}-Book`;
export const CIRCULAR_STD_BOOK_ITALIC = `${CIRCULAR_STD}-BookItalic`;
export const CIRCULAR_STD_MEDIUM = `${CIRCULAR_STD}-Medium`;
export const CIRCULAR_STD_BOLD = `${CIRCULAR_STD}-Bold`;

export function loadBrandFont() {
  return [
    cssFontFace(CIRCULAR_STD, CIRCULAR_STD_BOOK, 400),
    cssFontFace(CIRCULAR_STD, CIRCULAR_STD_MEDIUM, 500),
    cssFontFace(CIRCULAR_STD, CIRCULAR_STD_BOLD, 700),
    cssFontFace(CIRCULAR_STD, CIRCULAR_STD_BOOK_ITALIC, 300, 'italic')
  ];
}
